"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveUserFailed = exports.moveUserSuccess = exports.moveUserRequest = exports.toggleMoveUserModal = exports.removeUserFailed = exports.removeUserSuccess = exports.removeUserRequest = exports.removeGroupFailed = exports.removeGroupSuccess = exports.removeGroupRequest = exports.createEditFailed = exports.createEditSuccess = exports.createEditRequest = exports.createEditGroupModal = exports.clearState = exports.UsergroupInvite = exports.UsergroupList = void 0;
const ActionTypes = require("../../actionTypes/customer/userGroups");
const _usergroupInvite = require("../../modules/usergroup/invite/actions");
const _usergroupList = require("../../modules/usergroup/list/actions");
exports.UsergroupList = _usergroupList.default('customer/user-groups');
exports.UsergroupInvite = _usergroupInvite.default('customer/user-groups');
//#region List
const clearState = () => ({
    type: ActionTypes.CLEAR_STATE
});
exports.clearState = clearState;
//#endregion
//#region Create User Group
const createEditGroupModal = (mode = 'NONE', type, group) => ({
    type: ActionTypes.CREATE_EDIT_GROUP_MODAL,
    payload: {
        mode,
        type,
        group
    }
});
exports.createEditGroupModal = createEditGroupModal;
const createEditRequest = (payload) => ({
    type: ActionTypes.CREATE_EDIT_REQUEST,
    payload
});
exports.createEditRequest = createEditRequest;
const createEditSuccess = () => ({
    type: ActionTypes.CREATE_EDIT_SUCCESS
});
exports.createEditSuccess = createEditSuccess;
const createEditFailed = (error) => ({
    type: ActionTypes.CREATE_EDIT_FAILED,
    payload: error
});
exports.createEditFailed = createEditFailed;
// Remove groups
const removeGroupRequest = (customerId, group) => ({
    type: ActionTypes.REMOVE_GROUP_REQUEST,
    payload: { customerId, group }
});
exports.removeGroupRequest = removeGroupRequest;
const removeGroupSuccess = () => ({
    type: ActionTypes.REMOVE_GROUP_SUCCESS
});
exports.removeGroupSuccess = removeGroupSuccess;
const removeGroupFailed = (error) => ({
    type: ActionTypes.REMOVE_GROUP_FAILED,
    payload: error
});
exports.removeGroupFailed = removeGroupFailed;
// Remove users
const removeUserRequest = (customerId, items) => ({
    type: ActionTypes.REMOVE_USER_REQUEST,
    payload: { customerId, items }
});
exports.removeUserRequest = removeUserRequest;
const removeUserSuccess = () => ({
    type: ActionTypes.REMOVE_USER_SUCCESS
});
exports.removeUserSuccess = removeUserSuccess;
const removeUserFailed = (error) => ({
    type: ActionTypes.REMOVE_USER_FAILED,
    payload: error
});
exports.removeUserFailed = removeUserFailed;
// Move users
const toggleMoveUserModal = () => ({
    type: ActionTypes.TOGGLE_MOVE_USER_MODAL
});
exports.toggleMoveUserModal = toggleMoveUserModal;
const moveUserRequest = (customerId, target, users) => ({
    type: ActionTypes.MOVE_USER_REQUEST,
    payload: {
        customerId,
        target,
        users
    }
});
exports.moveUserRequest = moveUserRequest;
const moveUserSuccess = () => ({
    type: ActionTypes.MOVE_USER_SUCCESS
});
exports.moveUserSuccess = moveUserSuccess;
const moveUserFailed = (error) => ({
    type: ActionTypes.MOVE_USER_FAILED,
    payload: error
});
exports.moveUserFailed = moveUserFailed;
//#endregion
//# sourceMappingURL=userGroups.js.map